import { applicationKeys, IApplicationKeyParams } from './applicationKeys';

export interface IApplicationLoanRequestKeyParams
  extends IApplicationKeyParams {
  requestID: string;
}

export const applicationLoanRequestKeys = {
  root: (params: IApplicationLoanRequestKeyParams) =>
    [...applicationKeys.loanRequest(params), params.requestID] as const,
};

export function parseApplicationLoanRequestKey<
  T extends keyof typeof applicationLoanRequestKeys
>(queryKey: ReturnType<(typeof applicationLoanRequestKeys)[T]>) {
  const [, applicationID, , requestID] = queryKey;

  return { applicationID, requestID };
}
